module.exports = __webpack_public_path__ + "static/media/product-banner-1.5d0ae3ca.jpg";